import './Page1089Style.css';
import { FAILED_ICON } from '../common/failedIcon';

function Page1089Failed() {
  return (
    <div className="Aa3">
      <div className='container'>
        <div className='header'>
          <div className='header-right'>
            <div className='logo'><img alt='Kid Security' src='./../../kid-security-logo.png' /></div>
          </div>
        </div>
        <div className='form-content'>
          <div className='title'>
            <h4 id='headup-title'>{'Легко и безопасно'}</h4>
          </div>
          <div className='form-content-top'>
            <div className='logo'><img alt='Failed' src={FAILED_ICON} /></div>
          </div>
          <div className='form-content-middle'>
            <div className='title'>
              <h3 id='title'>{'Операция не удалась. Попробуйте позже.'}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page1089Failed;
